import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, map, mergeMap, throwError } from 'rxjs';
import { DOCUMENT } from '@angular/common';

import { AppService } from '../app.service';
import { AuthService } from '../auth.service';

//import { Photo } from '../shared/interfaces/photo';
import { User } from '../shared/interfaces/user';
import { Photo } from '../shared/interfaces/photo';
import { CustomHttpParams } from '../core/custom-http-params';

export interface PhotoCropResponse { 
  code: number,
  photo: {
    url: string
  } 
}

@Injectable({
  providedIn: 'root'
})
export class PhotoService {
  photoCropped = new BehaviorSubject<boolean>(false)
  croppedPhotoUrl = new BehaviorSubject<string | undefined>('')
  photoToCropInBase64: string | null = null
  showCropper!: { 
    data: File,
    temp?: string,
    size: { height: number; width: number; }
  } | null
  fileList = new BehaviorSubject<FileList | null>(null)
  photoFile: File | null = null

  private localStorage: Storage | null = null
  private showCropper$ = new BehaviorSubject<{
    data: File;
    size: { height: number; width: number };
  } | null>(null)

  constructor(
    private http: HttpClient, 
    private appService: AppService, 
    @Inject(DOCUMENT) private document: Document,
    private authService: AuthService,
  ) { 
    this.localStorage = this.document.defaultView?.localStorage || null
  }
  
  get(key: string): string {
    return this.localStorage?.getItem(key) || ''
  }

  set(key: string, value: string): void {
    this.localStorage?.setItem(key, value)
  }

  cropperState(): Observable<{
    data: File;
    size: { height: number; width: number };
  } | null> {
    return this.showCropper$.asObservable()
  }

  cropper(): void {
    //this.showCropper$.next(value);
  }

  saveOriginalPhoto(data: { origin: string; mime: string}, type: 'profile' | 'message', talkId?: string, content?: string): Observable<{ photo: { id: number, signed_url: string, url: string }}> {
    let body!: { type: string; mime_type: string; talking_id?: string, content?: string }
    if(type === 'profile'){
      body = {
        type,
        mime_type: data.mime
      }
    } else {
      body = {
        type,
        mime_type: data.mime,
        talking_id: talkId,
        content
      }
    }

    return this.http.post<{ photo: { id: number, signed_url: string, url: string }}>(`${this.appService.API}/api/photo`, body)
      .pipe(
        map((res) => {
          console.log(res)
          return res
        }),
        catchError((error) => {
          return throwError(() => error)
        })
      )
  }

  sendPhotoToSignedUrl(signedUrl: string, file: File, mimeType: string): Observable<string>{   
    const httpParams: CustomHttpParams = new CustomHttpParams(true, mimeType); // to override the default header through the interceptor

    return this.http.put<string>(signedUrl, file, {
      params: httpParams,  // to override the default header through the interceptor
    }).pipe(
      map(res => {
        console.log(res)
        return res
      }),
      catchError((error) => {
        return throwError(() => error)
      })
    )
  }

  cropPhoto(data: { x: number; y: number; height: number; width: number; preview?: string; }, photoId: number): Observable<Photo | undefined>{ //source: string, destination: string, 
    console.log('cropPhoto in photo service')

    const user: User = JSON.parse(this.get('user'))
    
    const bodyCrop = {
      x: data.x,
      y: data.y,
      height: data.height,
      width: data.width,
      photo_id: photoId
    }

    return this.http.post<PhotoCropResponse>(`${this.appService.API}/api/photo/crop`, bodyCrop).pipe(
      map((res: PhotoCropResponse) => {
        const result: Photo | undefined = res.photo

        if(!user.id) return
       
        return result
      }),
      catchError((error) => {
        return throwError(() => error)
      })
    )
  }

  setMainPhoto(id: number): Observable<{ photo: { id: number } }> {
    const body = { 
      photo_id: id.toString() 
    }

    return this.http
      .put<{ photo: { id: number } }>(`${this.appService.API}/photo/profile`, body)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((error) => {
          return throwError(() => error)
        }),
      );
  }

  deletePhoto(photoId: number): Observable<User> {
    return this.http
      .delete<{ code: number }>(`${this.appService.API}/api/user/photo?photo_id=${photoId.toString()}`)
      .pipe(
        mergeMap(() => {
          return this.authService.getProfile(Number(this.get('user_id'))).pipe(
            map((user) => {
              this.authService.setAuthMe(user)
              return user
            }),
            catchError((error) => {
              return throwError(() => error)
            }),
          );
        })
      )
  }
}
